<div fxLayout="column" fxLayoutAlign="start">
  <div class="page-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
    <div class="mat-display-1 page-title">Dashboard</div>
  </div>
  <div class="page-content">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start" fxLayoutGap="16px">
      <div fxFlex="65%">
        <div
          fxFlex.lt-md="100%"
          fxLayout="column"
          fxLayoutGap="16px"
          *appSkeletonLoader="{
            loading: loading,
            amountOfRows: 5,
            height: '24px',
            minWidth: '20%',
            maxWidth: '100%',
            inMatCard: false
          }"
        >
          <div fxLayout="row" fxLayoutAlign="space-between stretch">
            <mat-card style="padding: 0px" fxFlex="49%" [routerLink]="'/reports/54'" style="cursor: pointer;">
              <mat-card-content style="height: 86px">
                <div fxLayout="row" fxLayoutAlign="center stretch" style="height: 100%">
                  <div fxFlex="36px" class="warning-container">
                    <i class="material-icons warning-icon">warning</i>
                  </div>
                  <div fxFlex fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center stretch" style="height: 100%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="height: 100%; padding-left: 8px">
                      <span style="font-size: 40px; color: #dd7800">{{ counters?.WarningsCount || 0 }}</span>
                      <span fxFlex style="font-size: 20px">Mijn waarschuwingen</span>
                    </div>
                    <div class="sub-count" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <span  style="font-size: 20px">{{ counters?.AllWarningsCount || 0 }}</span>
                      <span fxFlex style="font-size: 16px">Alle waarschuwingen</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card style="padding: 0px" fxFlex="49%" [routerLink]="'/reports/25'" style="cursor: pointer;">
              <mat-card-content style="height: 86px">
                <div fxLayout="row" fxLayoutAlign="center stretch" style="height: 100%">
                  <div fxFlex="36px" class="dossier-container">
                    <i class="material-icons dossier-icon">folder_open</i>
                  </div>
                  <div fxFlex fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center stretch" style="height: 100%">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" style="height: 100%; padding-left: 8px">
                      <span style="font-size: 40px; color: #1f3242">{{ counters?.ToOpenDossiersCount || 0 }}</span>
                      <span fxFlex style="font-size: 20px">Mijn te heropenen dossiers</span>
                    </div>
                    <div class="sub-count" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                      <span style="font-size: 20px">{{ counters?.ToOpenAllDossiersCount || 0 }}</span>
                      <span fxFlex style="font-size: 16px">Alle te heropenen dossiers</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <mat-card>
            <mat-card-content>
              <div fxLayout="row" style="width: 100%" fxLayoutAlign="space-between stretch">
                <div fxLayout="row" style="width: 100%" fxFlex="49%">
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 40px;
                      background-color: #b4d9f8;
                      text-align: center;
                      padding: 0px 12px;
                    "
                  >
                    {{ counters?.WorkAssignmentsHighPrioCount + counters?.WorkAssignmentsCount }}
                  </div>

                  <div fxFlex style="display: flex; flex-direction: column; width: 100%">
                    <div
                      style="height: 30px; position: relative"
                      [matTooltip]="counters?.WorkAssignmentsHighPrioCount"
                      matTooltipPosition="above"
                    >
                      <div style="width: 100%; height: 100%; background: linear-gradient(90deg, #fff0f0 0%, #fff0f0 100%)"></div>
                      <div
                        style="
                          height: 100%;
                          background: linear-gradient(90deg, #fd0808 0%, #fe7c7c 100%, #fff0f0 100%);
                          position: absolute;
                          top: 0;
                          left: 0;
                          z-index: 1;
                          color: black;
                          display: flex;
                          align-items: center;
                        "
                        [style.width.%]="
                          getPercentage(
                            counters?.WorkAssignmentsHighPrioCount,
                            counters?.WorkAssignmentsCount + counters?.WorkAssignmentsHighPrioCount
                          )
                        "
                      >
                        <span style="margin-left: 6px">{{ counters?.WorkAssignmentsHighPrioCount }}</span>
                      </div>
                    </div>

                    <div
                      style="height: 30px; position: relative"
                      [matTooltip]="counters?.WorkAssignmentsCount"
                      matTooltipPosition="above"
                    >
                      <div style="width: 100%; height: 100%; background: linear-gradient(90deg, #fdf7ef 0%, #fdf7ef 100%)"></div>
                      <div
                        style="
                          height: 100%;
                          background: linear-gradient(90deg, #dd7800 0%, #edb878 100%);
                          position: absolute;
                          top: 0;
                          left: 0;
                          z-index: 1;
                          color: black;
                          display: flex;
                          align-items: center;
                        "
                        [style.width.%]="
                          getPercentage(
                            counters?.WorkAssignmentsCount,
                            counters?.WorkAssignmentsCount + counters?.WorkAssignmentsHighPrioCount
                          )
                        "
                      >
                        <span style="margin-left: 6px">{{ counters?.WorkAssignmentsCount }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div fxLayout="row" style="width: 100%" fxFlex="49%">
                  <div fxFlex style="display: flex; flex-direction: column; width: 100%">
                    <div
                      style="height: 30px; position: relative"
                      [matTooltip]="counters?.WorkAssignmentsAllHighPrioCount"
                      matTooltipPosition="above"
                    >
                      <div style="width: 100%; height: 100%; background: linear-gradient(270deg, #fff0f0 0%, #fff0f0 100%)"></div>
                      <div
                        style="
                          height: 100%;
                          background: linear-gradient(270deg, #fd0808 0%, #fe7c7c 100%, #fff0f0 100%);
                          position: absolute;
                          top: 0;
                          right: 0;
                          z-index: 1;
                          color: black;
                          display: flex;
                          align-items: center;
                          justify-content: flex-end;
                        "
                        [style.width.%]="
                          getPercentage(
                            counters?.WorkAssignmentsAllHighPrioCount,
                            counters?.WorkAssignmentsAllCount + counters?.WorkAssignmentsAllHighPrioCount
                          )
                        "
                      >
                        <span style="margin-right: 6px">{{ counters?.WorkAssignmentsAllHighPrioCount }}</span>
                      </div>
                    </div>

                    <div
                      style="height: 30px; position: relative"
                      [matTooltip]="counters?.WorkAssignmentsAllCount"
                      matTooltipPosition="above"
                    >
                      <div style="width: 100%; height: 100%; background: linear-gradient(270deg, #fdf7ef 0%, #fdf7ef 100%)"></div>

                      <div
                        style="
                          height: 100%;
                          background: linear-gradient(270deg, #dd7800 0%, #edb878 100%);
                          position: absolute;
                          top: 0;
                          right: 0;
                          z-index: 1;
                          color: black;
                          display: flex;
                          align-items: center;
                          justify-content: flex-end;
                        "
                        [style.width.%]="
                          getPercentage(
                            counters?.WorkAssignmentsAllCount,
                            counters?.WorkAssignmentsAllCount + counters?.WorkAssignmentsAllHighPrioCount
                          )
                        "
                      >
                        <span style="margin-right: 6px">{{ counters?.WorkAssignmentsAllCount }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 40px;
                      background-color: #b4d9f8;
                      text-align: center;
                      padding: 0px 12px;
                    "
                  >
                    {{ counters?.WorkAssignmentsAllCount + counters?.WorkAssignmentsAllHighPrioCount }}
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center" style="font-size: 16px; line-height: 24px;">
                <div style="margin-top: 6px;">Mijn werkopdrachten</div>
                <div style="margin-top: 6px;">Alle werkopdrachten</div>
              </div>
            </mat-card-content>
          </mat-card>

          <div fxLayout="column" style="padding-top: 16px" fxLayoutGap="8px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <div style="font-size: 20px">Wonen ( met vrijstelling )</div>
              <div fxFlex class="divider"></div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="16px">
              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="25%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.LSCount }}
                    <span *ngIf="counters?.LSExemptionCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.LSExemptionCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Leegstand</div>
                </div>

                <div
                  style="width: 24px; height: 100%; position: relative"
                  [matTooltip]="counters?.LSExemptionCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="getPercentage(counters?.LSCount - counters?.LSExemptionCount, counters?.LSCount)"
                  ></div>
                </div>
              </mat-card>

              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="25%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.VWCount }}
                    <span *ngIf="counters?.VWExemptionCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.VWExemptionCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Verwaarlozing</div>
                </div>

                <div
                  style="width: 24px; height: 100%; position: relative"
                  [matTooltip]="counters?.VWExemptionCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="getPercentage(counters?.VWCount - counters?.VWExemptionCount, counters?.VWCount)"
                  ></div>
                </div>
              </mat-card>

              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="25%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.OOCount }}
                    <span *ngIf="counters?.OOExemptionCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.OOExemptionCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Woonkwaliteit</div>
                </div>

                <div
                  style="width: 24px; height: 100%; position: relative"
                  [matTooltip]="counters?.OOExemptionCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "

                    [style.height.%]="getPercentage(counters?.OOCount - counters?.OOExemptionCount, counters?.OOCount)"
                  ></div>
                </div>
              </mat-card>

              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="25%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.SRCount }}
                    <span *ngIf="counters?.SRExemptionCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.SRExemptionCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">{{ labelSecondaryResidence }}</div>
                </div>

                <div
                  style="width: 24px; height: 100%; position: relative"
                  [matTooltip]="counters?.SRExemptionCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="getPercentage(counters?.SRCount - counters?.SRExemptionCount, counters?.SRCount)"
                  ></div>
                </div>
              </mat-card>

              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="25%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.HWCount }}
                    <span *ngIf="counters?.HWExemptionCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.HWExemptionCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Huurwoningen</div>
                </div>

                <div
                  style="width: 24px; height: 100%; position: relative"
                  [matTooltip]="counters?.SRExemptionCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="getPercentage(counters?.HWCount - counters?.HWExemptionCount, counters?.HWCount)"
                  ></div>
                </div>
              </mat-card>
            </div>
          </div>

          <div fxLayout="column" style="padding-top: 16px" fxLayoutGap="8px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <div style="font-size: 20px">Bedrijven en handelspanden ( met vrijstelling )</div>
              <div fxFlex class="divider"></div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="16px">
              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="50%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.LSCompanyCount }}
                    <span *ngIf="counters?.LSExemptionCompanyCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.LSExemptionCompanyCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Leegstand</div>
                </div>

                <div
                  style="width: 50%; height: 100%; position: relative"
                  [matTooltip]="counters?.LSExemptionCompanyCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      height: 80%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="
                      getPercentage(
                        counters?.LSCompanyCount - counters?.LSExemptionCompanyCount,
                        counters?.LSCompanyCount
                      )
                    "
                  ></div>
                </div>
              </mat-card>

              <mat-card
                style="height: 130px; width: 100%; padding: 0px"
                fxLayout="row"
                fxFlex="50%"
                fxLayoutAlign="space-between center"
              >
                <div fxFlex style="display: flex; flex-direction: column; justify-content: center; padding-left: 20px">
                  <div style="font-size: 40px; color: #1c3243">
                    {{ counters?.VWCompanyCount }}
                    <span *ngIf="counters?.VWExemptionCompanyCount" style="font-size: 20px; position: relative; top: -2px"
                      >( {{ counters?.VWExemptionCompanyCount }} )</span
                    >
                  </div>
                  <div style="font-size: 18px; color: #5c6b7a; margin-top: 10px">Verwaarlozing</div>
                </div>

                <div
                  style="width: 50%; height: 100%; position: relative"
                  [matTooltip]="counters?.VWExemptionCompanyCount"
                  matTooltipPosition="above"
                >
                  <div style="width: 100%; height: 100%; border-radius: 6px 6px 6px 6px; background: #ebfaf2"></div>
                  <div
                    style="
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      z-index: 1;
                      border-radius: 6px 6px 6px 6px;
                      background: linear-gradient(180deg, #90cba9 0%, #219653 100%);
                    "
                    [style.height.%]="
                      getPercentage(
                        counters?.VWCompanyCount - counters?.VWExemptionCompanyCount,
                        counters?.VWCompanyCount
                      )
                    "
                  ></div>
                </div>
              </mat-card>
            </div>
          </div>

          <div fxLayout="column" style="padding-top: 16px" fxLayoutGap="8px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <div style="font-size: 20px">Modules</div>
              <span style="font-size: 14px; color: #5c6b7a">({{ activeModuleCount }}/{{ modules.length }})</span>
              <div fxFlex class="divider"></div>
            </div>

            <mat-card>
              <mat-card-content>
                <div class="modules-grid">
                  <div
                    [matTooltip]="module.IsActive ? '' : 'U heeft deze module niet. Voor meer informatie kan u contact opnemen via support@neglect-x.be'"
                    class="module-item"
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    fxLayoutGap="8px"
                    *ngFor="let module of modules"
                  >
                    <mat-icon class="module-status-icon" [ngClass]="module.IsActive ? 'module-active' : 'module-inactive'">
                      {{ module.IsActive ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                    <span fxFlex class="module-name">{{ module.Name }}</span>
                    <button
                      *ngIf="module.InfoUrl"
                      mat-icon-button
                      class="module-info-btn"
                      (click)="onModuleInfoClick(module)"
                      matTooltip="Meer info over {{ module.Name }}"
                    >
                      <mat-icon>info_outline</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>

      <div fxFlex="35%" fxFlex.lt-md="100%" fxLayout="column" fxLayoutGap="16px">
        <ng-container *ngIf="messages?.length > 1">
          <mat-card
            *appSkeletonLoader="{
              loading: loading,
              amountOfRows: 5,
              height: '24px',
              minWidth: '20%',
              maxWidth: '50%',
              inMatCard: true
            }"
          >
            <mat-card-title>Boodschap van algemeen nut</mat-card-title>
            <mat-card-content>
              <div fxLayout="column">
                <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
                  <ng-container>
                    <markdown [data]="messages[selectedMessageIndex].Markdown" emoji ngPreserveWhitespaces></markdown>
                  </ng-container>
                </div>

                <div fxLayoutAlign="center center" fxLayoutGap="12px" *ngIf="messages?.length > 1">
                  <ng-container *ngFor="let message of messages; let i = index">
                    <div [ngClass]="selectedMessageIndex === i ? 'dot-active' : 'dot'" (click)="selectedMessageIndex = i"></div>
                  </ng-container>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <mat-card *appSkeletonLoader="{
              loading: loading,
              amountOfRows: 1,
              height: '24px',
              minWidth: '20%',
              maxWidth: '100%',
              inMatCard: true
            }">
          <mat-card-title
            fxLayout="row"
            fxLayoutAlign="space-between center"

          >
            <span>Kaart</span>
            <mat-button-toggle-group multiple value="LS" (change)="onToggleChange($event)">
              <mat-button-toggle value="LS" class="toggle-ls">LS</mat-button-toggle>
              <mat-button-toggle value="VW" class="toggle-vw">VW</mat-button-toggle>
              <mat-button-toggle value="OO" class="toggle-oo">OO</mat-button-toggle>
              <mat-button-toggle value="TT" class="toggle-tt">TT</mat-button-toggle>
            </mat-button-toggle-group>
          </mat-card-title>
          <div  id="map" style="height: 400px" ></div>
        </mat-card>
        <mat-card>
          <mat-card-title>Laatst geopende dossiers</mat-card-title>
          <mat-card-content>
            <div class="list">
              <div fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                <div
                  fxLayout="row"
                  fxLayoutGap="16px"
                  [style.width]="'100%'"
                  fxLayoutAlign="space-between center"
                  class="list-item"
                  routerLink="/dossiers/{{ dossier.Code }}"
                  *ngFor="let dossier of appState.lastVisitDossiers$.value"
                >
                  <div fxLayout="column" fxLayoutGap="0px" fxFlex="95%" fxLayoutAlign="start start">
                    <div fxLayout="row" fxLayoutGap="16px" [style.width]="'100%'" fxLayoutAlign="space-between center">
                      <div
                        fxLayout="row"
                        fxFlex="20%"
                        fxLayoutAlign="start center"
                        fxLayoutGap="16px"
                        class="owner-name"
                        style="font-size: 16px; color: #1f3242; font-weight: 500"
                      >
                        {{ dossier.Code }}
                      </div>

                      <div fxLayout="column" fxFlex="80%" fxLayoutAlign="end end">
                        <div style="font-size: 14px; color: #576571">
                          {{ dossier.BuildingTypeDescription }}
                        </div>

                        <div style="font-size: 14px; color: #1f3242; text-align: right">
                          {{ dossier.Street }} {{ dossier.HouseNumber }}<ng-container *ngIf="dossier.BoxNumber"> bus {{ dossier.BoxNumber }}</ng-container>, {{ dossier.PostalCode }} {{ dossier.City }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="appState.lastVisitDossiers$.value?.length <= 0"> Nog geen dossiers bewerkt </ng-container>
          </mat-card-content>
        </mat-card>


      </div>
    </div>
  </div>
</div>
